import {isDevOrPrisoft} from '../../utils/platform';

const configuration = {
    days: isDevOrPrisoft() ? 10 : 30,
    neverFormKey: '',
    neverAllKey: '',
    cookieKey: 'personalizationCookie',
    maxAppearances: 1
};

export {configuration};
